import { render } from "./AccountsDashboard.vue?vue&type=template&id=636a7cc7"
import script from "./AccountsDashboard.vue?vue&type=script&lang=js"
export * from "./AccountsDashboard.vue?vue&type=script&lang=js"

import "./AccountsDashboard.vue?vue&type=style&index=0&id=636a7cc7&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__